import React from "react";
import { upcomingEvents } from "../data/site";
import { EventsSection } from "../components/events/EventsSection";
import { SiteHeader } from "../components/header/SiteHeader";
import { AccidentHelp } from "../components/home/AccidentHelp";
import { CaseReviewSection } from "../components/home/CaseReviewSection";
import { CommonAnswers } from "../components/home/CommonAnswers";
import { CaseResult } from "../components/home/CaseResult";
import { Hero } from "../components/home/Hero";
import { TrustSection } from "../components/home/TrustSection";
import { SiteStatement } from "../components/SiteStatement";
import { SiteFooter } from "../components/SiteFooter";
type HomeProps = {
  showReviewNotes: boolean;
  showEmptyEvents: boolean;
};
export function Home({
  showReviewNotes,
  showEmptyEvents
}: HomeProps) {
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-245" data-mp="3kuqvf96ejtj3">
      <a href="#main" className="sr-only left-4 top-4 z-50 rounded-md bg-ink px-5 py-3 text-label font-bold text-white focus:not-sr-only focus:absolute" data-id="element-246" data-mp="3owcejc9j541q">
        Skip to main content
      </a>
      <SiteStatement data-id="element-247" data-mp="2vyq6txqmm254" />
      <SiteHeader data-id="element-248" data-mp="2vy81mblzkdl2" />
      <main id="main" data-id="element-249" data-mp="2vvltoav6nw2b">
        <Hero data-id="element-250" data-mp="2qybwua5gsi4g" />
        <CaseResult data-id="element-251" data-mp="2qy2f19ukph9u" />
        <TrustSection data-id="element-252" data-mp="2qxal03gmjrlo" />
        <AccidentHelp data-id="element-253" data-mp="2qwsjarb70l6d" />
        <CommonAnswers data-id="element-254" data-mp="2mx0hqyk7vfai" />
        <CaseReviewSection showReviewNotes={showReviewNotes} data-id="element-255" data-mp="2mxjqpprw2tce" />
        <EventsSection events={showEmptyEvents ? [] : upcomingEvents} data-id="element-256" data-mp="2mzcvezixz3hr" />
      </main>
      <SiteFooter data-id="element-257" data-mp="2hz8ex9i1a8rj" />
    </div>;
}